const RosterLegend = () => (
  <div className="mt-4 p-4 bg-dry border border-border rounded text-sm">
    <div className="flex flex-wrap gap-6 mb-3 items-center text-textGray">
      <span className="font-semibold ">Key:</span>
      <span>✔ Working</span>
      <span>✖ Not working</span>

      <span className="flex items-center gap-2">
        <span className="w-5 h-5 rounded bg-yellowlight" />
        Normal working hours
      </span>

      <span className="flex items-center gap-2">
        <span className="w-5 h-5 rounded bg-yellowdark" />
        Modified working hours
      </span>

      <span className="flex items-center gap-2">
        <span className="w-5 h-5 rounded bg-drylightextra" />
        Business closed
      </span>

      <span className="text-subMain cursor-pointer underline">Edit</span>
    </div>

    <p className="text-textGray">
      To adjust working hours for a staff person click the start or end time on
      a specific date. To toggle whether they are working or not click the ✔ or
      ✖ icons.
    </p>
  </div>
);

export default RosterLegend;
